import { Slide } from '@/components/core/Slide';

export const slide = () => {
  return (
    <Slide notes="ChatGPT advanced features overview" transition="fade" networkBackground="full">
      <div className="relative z-10 flex flex-col justify-center h-full px-24 py-8 text-left slide-scale-75">
        <h2 className="title">ChatGPT Advanced Features</h2>

        <div className="grid grid-cols-2 gap-8 mt-8">
          <div className="space-y-4">
            <h3 className="text-2xl font-semibold mb-4">Custom GPTs</h3>
            <div className="space-y-2">
              <p>• Midjourney prompter</p>
              <p>• Sora prompter</p>
              <p>• API/tool calling</p>
              <p>• Persona-creatie en gebruik</p>
            </div>
          </div>

          <div className="space-y-4">
            <h3 className="text-2xl font-semibold mb-4">Project Management</h3>
            <div className="space-y-2">
              <p>• Project folders met instructies</p>
              <p>• Structureren van projecten</p>
            </div>
          </div>

          <div className="space-y-4">
            <h3 className="text-2xl font-semibold mb-4">Automation</h3>
            <div className="space-y-2">
              <p>• Websites bedienen</p>
              <p>• Workflow automatisering</p>
            </div>
          </div>

          <div className="space-y-4">
            <h3 className="text-2xl font-semibold mb-4">Advanced Tools</h3>
            <div className="space-y-2">
              <p>• Memory/Bio tool</p>
              <p>• Custom instructions</p>
              <p>• Deep Research</p>
            </div>
          </div>
        </div>
      </div>
    </Slide>
  );
};
